enum ApiCallType {
	Alert = 1,
	KioskSession = 2,
	NavSession = 4,
	CashBoxRemoved = 8,
	PaymentAccepted = 16,
	PaymentRejected = 32,
	DigitalReceipt = 64,
	PaymentRequestCash = 128,
	PaymentRequestCard = 256,
	PaymentRequestCheck = 512,
	LookupRequest = 1024,
	PrepareTransaction = 2048,
	PaymentRequestToken = 4096,
}

export default ApiCallType;
